import styled, { keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";

// Define shimmer animation (Right side only)
const shimmer = keyframes`
  0% {
    background-position: 150% 0;
  }
  100% {
    background-position: -150% 0;
  }
`;

const BaseSkeleton = styled.div`
  background: linear-gradient(
    90deg,
    #f1f1f1 30%,
    #f1f1f1 40%,
    #f1f1f1 50%,
    #fefefe 65%,
    #f1f1f1 80%
  );

  background-size: 300% 100%;
  animation: ${shimmer} 5.5s infinite linear;
`;

export const SquareSkeleton = styled(BaseSkeleton)`
  width: ${({ width }) => viewSizeCalculator(width ? width : 1.6)};
  height: ${({ height }) => viewSizeCalculator(height ? height : 1.6)};
  border-radius: ${viewSizeCalculator(0.5)};
`;

export const TextSkeleton = styled(BaseSkeleton)`
  width: ${({ width }) => (width ? viewSizeCalculator(width) : "100%")};
  height: ${({ height }) => viewSizeCalculator(height ? height : 1.6)};

  background-size: 300% 100%;
  border-radius: ${({ borderRadius }) =>
    viewSizeCalculator(borderRadius ? borderRadius : 0.45)};
`;
